import Cookies from "js-cookie";
import { React, useState, useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Slide, toast } from "react-toastify";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  fetchProductMasterColumn,
} from "../../services/productMasterService";
 
// external
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { fetchProductMasterAttribute } from "./FilterService";
 
import "../../style/productmaster.css";
 
// button style
const CancelButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  padding: "3px 10px",
  border: "1px solid #DA6868",
  color: "#DA6868",
  lineHeight: 1.5,
  backgroundColor: "#FFF",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#F0F0F0",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#F0F0F0",
    borderColor: "#DA6868",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(243, 91, 91, 0.5)",
  },
});
 
const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  padding: "3px 10px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});
 
function AddProductPage(data) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isGeneratingId, setIsGeneratingId] = useState(false);
  const [dataBrandMaster, setDataBrandMaster] = useState([]);
  const [dataCategoryMaster, setDataCategoryMaster] = useState([]);
  const [dataPrincipalMaster, setDataPrincipalMaster] = useState([]);
  const [dataPrincipalFilteredMaster, setDataPrincipalFilteredMaster] = useState([]);
  const [unitVolume, setUnitVolume] = useState("");
 
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [dataProfile, setDataProfile] = useState([]);
 
  const [selectedFilteredCategory, setSelectedFilteredCategory] = useState("");
 
  // Satu state buat semua product attribute (packsize, packtype, flavour, segment_1/2/3),
  // hasil 1x fetch ke /api/v1/product-master-attribute, dikelompokkan di frontend.
  const [productAttributes, setProductAttributes] = useState([]);
 
  const filteredPackSize = useMemo(
    () => productAttributes.filter((a) => a.atribut === "packsize"),
    [productAttributes]
  );
  const filteredPackType = useMemo(
    () => productAttributes.filter((a) => a.atribut === "packtype"),
    [productAttributes]
  );
  const filteredFlavour = useMemo(
    () => productAttributes.filter((a) => a.atribut === "flavour"),
    [productAttributes]
  );
  const filteredSegment1 = useMemo(
    () => productAttributes.filter((a) => a.atribut === "segment_1"),
    [productAttributes]
  );
  const filteredSegment2 = useMemo(
    () => productAttributes.filter((a) => a.atribut === "segment_2"),
    [productAttributes]
  );
  const filteredSegment3 = useMemo(
    () => productAttributes.filter((a) => a.atribut === "segment_3"),
    [productAttributes]
  );
 
  async function fetchBrandMaster() {
    const token = Cookies.get("access_token") || "";
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/brand-master`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
 
      if (response.ok) {
        const data = await response.json();
        setDataBrandMaster(data.data);
      } else {
        alert("Gagal Mengambil Data");
      }
    } catch (error) {
      console.error("Ada masalah, error :", error);
    }
  }
 
  async function fetchCategoryMaster() {
    const token = Cookies.get("access_token") || "";
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/category-master`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
 
      if (response.ok) {
        const data = await response.json();
        setDataCategoryMaster(data.data);
      } else {
        alert("Gagal Mengambil Data");
      }
    } catch (error) {
      console.error("Ada masalah, error :", error);
    }
  }
 

  async function fetchCategoryBrandMaster(brandId, categoryId) {
    if (!brandId || !categoryId) {
      setDataPrincipalFilteredMaster([]);
      setNewProductData((prev) => ({
        ...prev,
        principal_master_id: "",
      }));
      return;
    }
 
    const token = Cookies.get("access_token") || "";
 
    const queryParams = new URLSearchParams();
    queryParams.append("brand_master_id", brandId);
    queryParams.append("category_master_id", categoryId);
 
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/brand-category-master?` +
      queryParams.toString();
 
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
 
      if (response.ok) {
        const data = await response.json();
        setDataPrincipalFilteredMaster(data.data);
      } else {
        setDataPrincipalFilteredMaster([]);
        setNewProductData((prev) => ({
          ...prev,
          principal_master_id: "",
        }));
      }
    } catch (error) {
      console.error("Ada masalah, error :", error);
      setDataPrincipalFilteredMaster([]);
    }
  }
 
  async function fetchPrincipalMaster() {
    const token = Cookies.get("access_token") || "";
 
    const queryParams = new URLSearchParams();
 
    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/principal-master` +
      (queryString ? `?${queryString}` : "");
 
    try {
      const response = await fetch(apiUrl,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
 
      if (response.ok) {
        const data = await response.json();
        setDataPrincipalMaster(data.data);
      } else {
        alert("Gagal Mengambil Data");
      }
    } catch (error) {
      console.error("Ada masalah, error :", error);
    }
  }
 
  // token
  const token = Cookies.get("access_token") || "";
 
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchCategoryMaster();
      fetchBrandMaster();
      fetchProductMasterColumn(dispatch, token);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);
 
  const [newProductData, setNewProductData] = useState({
    product_id: "",
    product_name: "",
    barcode: "",
    category_master_id: "",
    principal_master_id: "",
    brand_master_id: "",
    packsize: "",
    packtype: "Any",
    flavour: "Flavour",
    segment_1: "",
    segment_2: "",
    segment_3: "",
    convertedvol: 0,
    ctrl_price: 0,
  });
 
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPrincipalMaster();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);
 
  // auto-generate product_id begitu category_master_id terisi
  useEffect(() => {
    if (!newProductData.category_master_id) {
      return;
    }
 
    let isCancelled = false;
 
    async function generateProductId() {
      setIsGeneratingId(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/product-master/generate-id`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              category_master_id: newProductData.category_master_id,
            }),
          }
        );
 
        if (response.status === 200) {
          const data = await response.json();
          if (!isCancelled && data?.product_id) {
            setNewProductData((prevState) => ({
              ...prevState,
              product_id: data.product_id,
            }));
          }
        }
      } catch (error) {
        console.error("Error generating product id:", error);
      } finally {
        if (!isCancelled) {
          setIsGeneratingId(false);
        }
      }
    }
 
    generateProductId();
 
    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newProductData.category_master_id, token]);
 
  const handleProductInputChange = (event) => {
    const { name, value } = event.target;
    setNewProductData((prev) => ({
      ...prev,
      [name]: value,
    }));
 
    if (name === "category_master_id") {
      setSelectedFilteredCategory(value);
    }
  };
 
  const handleCreateProduct = async () => {
    if (!newProductData.product_id || !newProductData.product_id.trim()) {
      toast.error(
        "Code belum tersedia. Pastikan Category sudah dipilih dan proses generate selesai.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        }
      );
      return;
    }
 
    const token = Cookies.get("access_token");
    setIsLoading(true);
    try {
      const createProductData = {
        ...newProductData,
        product_id: newProductData.product_id.trim(),
        product_name: newProductData.product_name.trim(),
      };
 
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/product-master`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(createProductData),
        }
      );
 
      if (response.status === 201) {
        toast.success("Product berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        setTimeout(function () {
          handleRedirect();
        }, 500);
      } else if (response.status === 400 || response.status === 404) {
        const data = await response.json();
        alert(data.detail);
      } else {
        alert("Product gagal dibuat!");
      }
    } catch (error) {
      console.error("Error creating product:", error);
    }
    setIsLoading(false);
  };
 
  const handleRedirect = () => {
    const selectedProductGroupId = localStorage.getItem('selectedProductGroupId');
    const selectedCategory = localStorage.getItem('selectedCategory');
    const selectedPrincipal = localStorage.getItem('selectedPrincipal');
    const selectedBrand = localStorage.getItem('selectedBrand');
    const filterColumnName = localStorage.getItem('filterColumnName');
    const filterColumnValue = localStorage.getItem('filterColumnValue');
 
    const queryParams = new URLSearchParams();
 
    if (selectedProductGroupId) {
      queryParams.append('product_group_master_id', selectedProductGroupId);
    }
    if (selectedCategory) {
      queryParams.append('category_master_id', selectedCategory);
    }
    if (selectedPrincipal) {
      queryParams.append('principal_master_id', selectedPrincipal);
    }
    if (selectedBrand) {
      queryParams.append('brand_master_id', selectedBrand);
    }
    if (filterColumnName) {
      queryParams.append('column_name', filterColumnName);
    }
    if (filterColumnValue) {
      queryParams.append('column_value', filterColumnValue);
    }
 
    const queryString = queryParams.toString();
    const redirectUrl = `/product-master` + (queryString ? `?${queryString}` : '');
 
    window.location.replace(redirectUrl);
  };
 
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(token, setDataProfile, setNotAllowAccessPage, [
        "TL",
        "13",
        "14",
      ]);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, []);
 
  // 1 endpoint aja buat semua product attribute; pengelompokan packsize/packtype/flavour/segment_1/2/3
  // dilakukan lewat useMemo di atas.
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProductMasterAttribute(token, setProductAttributes, selectedFilteredCategory);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [selectedFilteredCategory]);
 
  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Product Master"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allow to access this page</div>
      </div>
    );
  }
  return (
    <div>
      <Navbar
        active="Product Master"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ width: "70%", margin: "0 auto" }}>
        <h2 style={{ textAlign: "center", mt: 2, mb: 2 }}>
          Add Product Master
        </h2>
        <div>
          <Grid
            container
            spacing={2}
            sx={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Grid item xs={12} sm={6}>
              <Grid container justifyContent="flex-end">
                <Grid item xs={12} mb={2}>
                  <TextField
                    label="Code"
                    name="product_id"
                    value={newProductData.product_id}
                    onChange={handleProductInputChange}
                    sx={{ width: "100%" }}
                    helperText={
                      isGeneratingId
                        ? "Sedang membuat Code..."
                        : "Otomatis terisi setelah Category dipilih (bisa diubah manual)."
                    }
                    FormHelperTextProps={{
                      sx: {
                        color: isGeneratingId ? "#b34469" : "#1976d2",
                        fontStyle: "italic",
                        fontSize: "0.75rem",
                      },
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <TextField
                    label="Product"
                    name="product_name"
                    value={newProductData.product_name}
                    onChange={handleProductInputChange}
                    sx={{ width: "100%" }}
                    required
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <TextField
                    label="Barcode"
                    name="barcode"
                    value={newProductData.barcode}
                    onChange={handleProductInputChange}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={dataCategoryMaster || []}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      dataCategoryMaster?.find(
                        (option) =>
                          option.id === newProductData.category_master_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      const newCategoryId = newValue ? newValue.id : "";
                      handleProductInputChange({
                        target: {
                          name: "category_master_id",
                          value: newCategoryId,
                        },
                      });
                      setUnitVolume(newValue ? newValue.unitvolume : "");
                      fetchCategoryBrandMaster(
                        newProductData.brand_master_id,
                        newCategoryId
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Category"
                        sx={{ width: "100%" }}
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={dataBrandMaster || []}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      dataBrandMaster?.find(
                        (option) => option.id === newProductData.brand_master_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      const newBrandId = newValue ? newValue.id : "";
                      handleProductInputChange({
                        target: {
                          name: "brand_master_id",
                          value: newBrandId,
                        },
                      });
                      fetchCategoryBrandMaster(
                        newBrandId,
                        newProductData.category_master_id
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Brand"
                        required
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  {dataPrincipalFilteredMaster.length > 0 ? (
                    <Autocomplete
                      options={dataPrincipalFilteredMaster || []}
                      getOptionLabel={(option) => option.principal_master || ""}
                      value={
                        dataPrincipalFilteredMaster?.find(
                          (option) =>
                            option.principal_master_id === newProductData.principal_master_id
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleProductInputChange({
                          target: {
                            name: "principal_master_id",
                            value: newValue ? newValue.principal_master_id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Filtered Principal Master"
                          sx={{ width: "100%" }}
                          required
                        />
                      )}
                    />
                  ) : (
                    <Autocomplete
                      options={dataPrincipalMaster || []}
                      getOptionLabel={(option) => option.name || ""}
                      value={
                        dataPrincipalMaster?.find(
                          (option) =>
                            option.id === newProductData.principal_master_id
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        handleProductInputChange({
                          target: {
                            name: "principal_master_id",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Principal Master"
                          sx={{ width: "100%" }}
                          required
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredPackSize || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredPackSize?.find(
                        (option) =>
                          option.atribut_value === newProductData.packsize
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "packsize",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Pack Size"
                        sx={{ width: "100%" }}
                        required
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid container justifyContent="flex-start">
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredPackType || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredPackType?.find(
                        (option) =>
                          option.atribut_value === newProductData.packtype
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "packtype",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Pack Type"
                        sx={{ width: "100%" }}
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredFlavour || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredFlavour?.find(
                        (option) =>
                          option.atribut_value === newProductData.flavour
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "flavour",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Flavour"
                        sx={{ width: "100%" }}
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredSegment1 || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredSegment1?.find(
                        (option) =>
                          option.atribut_value === newProductData.segment_1
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "segment_1",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Segment 1"
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredSegment2 || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredSegment2?.find(
                        (option) =>
                          option.atribut_value === newProductData.segment_2
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "segment_2",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Segment 2"
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <Autocomplete
                    options={filteredSegment3 || []}
                    getOptionLabel={(option) => option.atribut_value || ""}
                    value={
                      filteredSegment3?.find(
                        (option) =>
                          option.atribut_value === newProductData.segment_3
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleProductInputChange({
                        target: {
                          name: "segment_3",
                          value: newValue ? newValue.atribut_value : "",
                        },
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Segment 3"
                        sx={{ width: "100%" }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <TextField
                    label={`Converted Volume${
                      unitVolume ? ` (${unitVolume})` : ""
                    }`}
                    name="convertedvol"
                    value={newProductData.convertedvol}
                    onChange={handleProductInputChange}
                    sx={{ width: "100%" }}
                    required
                  />
                </Grid>
                <Grid item xs={12} mb={2}>
                  <TextField
                    label="Control Price"
                    name="ctrl_price"
                    value={newProductData.ctrl_price}
                    onChange={handleProductInputChange}
                    sx={{ width: "100%" }}
                    required
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  mb={2}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2
                  }}
                >
                  <CancelButton
                    variant="contained"
                    disableRipple
                    sx={{ height: 55, width: "50%", mb: 3 }}
                    onClick={handleRedirect}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Cancel"}
                  </CancelButton>
                  <BootstrapButton
                    variant="contained"
                    disableRipple
                    sx={{ height: 55, width: "50%", mb: 3 }}
                    onClick={handleCreateProduct}
                    disabled={isLoading || isGeneratingId}
                  >
                    {isLoading
                      ? "Loading..."
                      : isGeneratingId
                      ? "Generating ID..."
                      : "Submit"}
                  </BootstrapButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
 
export default AddProductPage;